import React, { useState, useEffect, useMemo } from 'react'
import { capitalizeAndRemoveUnderscores, limitWords, formatDateAndTime, downloadFile } from '../../utils/utils';
import { Table, Button, Tooltip, message } from "antd";
import FileTextIcon from "../../components/icons/FileTextIcon";
import EyeOutlineIcon from "../../components/icons/EyeOutlineIcon";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/axiosInstance";
import { useSelector } from 'react-redux';
import EmailOutlineIcon from '../../components/icons/EmailOutlineIcon';

export default function RecentContractsAudit() {
    const [recentContracts, setRecentContracts] = useState([]);
    const [errorMessageShown, setErrorMessageShown] = useState(false);
    const comp_id = useSelector((store) => store.auth.userInfo.company_id);
    const company_id = localStorage.getItem("companyId");
    const [hasBeenShown, setHasBeenShown] = useState(false);
    const navigate = useNavigate();

    const handleChangeView = async (prev, curr, e) => {
        e.stopPropagation();
        console.log(prev, curr)
        try {
            setHasBeenShown(true);
            if (!prev || !curr) {
                message.error("Both previous and current file must be selected.");
                return;
            }
            const res = await axiosInstance.post(`contract/Compare/`, {
                original_url: prev,
                revised_url: curr,
            });

            console.log("handleChangeView Response:", res.data);

            const diffSFDT = res?.data?.sfdt;
            if (diffSFDT) {
                localStorage.setItem('diff_sfdt', JSON.stringify(diffSFDT));
                window.open('/version-diff-viewer', '_blank');
            } else {
                message.warning("No differences found.");
            }

        } catch (error) {
            const errorMsg = error.response?.data?.error || "Failed to fetch the differences.";
            message.error(errorMsg);
            console.error("handleChangeView Error:", error);
        } finally {
            setHasBeenShown(false);
        }
    };


    const handleViewClick = (link, name, e) => {
        e.stopPropagation();
        if (link) {
            //   downloadFile(link);
            downloadFile(link, name)
            // Reset error message state
            setErrorMessageShown(false);
        } else {
            // Show error message only if it hasn't been shown already
            if (!errorMessageShown) {
                message.error("Document does not exist.");
                setErrorMessageShown(true);
                // Automatically reset error message state after 2 seconds (5000 milliseconds)
                setTimeout(() => {
                    setErrorMessageShown(false);
                }, 2000);
            }
        }
    };

    const columns = useMemo(() => [
        {
            title: "Partner Name",
            dataIndex: "name_of_client",
            ellipsis: true,
            width: 100,
            key: "name_of_client",
            render: (text) => <span >{text}</span>,
        },

        {
            title: "Agreement Type",
            dataIndex: "agreement_type",
            ellipsis: true,
            width: 140, // Increase width
            key: "agreement_type",
            render: (text) => (
                <span >{limitWords(text, 12)}</span>
            ),
        },


        {
            title: "Status",
            ellipsis: true,
            key: "status",
            width: 100,
            dataIndex: "status",
            render: (text) => capitalizeAndRemoveUnderscores(text),
        },

        {
            title: "Last modified User",
            width: 100,
            ellipsis: true,
            dataIndex: "editable_username",
            render: (document, record) => (
                <span>{document && document}</span>
            ),
        },
        {
            title: "Last Modified Time",
            dataIndex: "modified_at",
            width: 100,
            ellipsis: true,
            render: (document, record) => (
                <span>{document && formatDateAndTime(document)}</span>
            ),
        },
        {
            title: "Current Version",
            dataIndex: "agreement",
            ellipsis: true,
            width: 100,
            render: (text, record) => (
                <>
                    <Button
                        onClick={(e) => handleViewClick(record?.contract_history?.[0]?.current_agreement, record?.document_id, e)}
                        type="submit"
                    >
                        <FileTextIcon />
                    </Button>
                </>
            ),
        },
        {
            title: "Compared Version",
            dataIndex: "agreement",
            ellipsis: true,
            width: 100,
            render: (text, record) => {
                const prev = record?.contract_history?.[0]?.previous_agreement;
                const curr = record?.contract_history?.[0]?.current_agreement;
                let disabled = false;
                let tooltipMessage = "Click to Compare";

                if (!prev || !curr) {
                    disabled = true;
                    tooltipMessage = "No file available";
                } else if (prev.endsWith(".pdf") || curr.endsWith(".pdf")) {
                    disabled = true;
                    tooltipMessage = "File contains PDF";
                }

                return (
                    <Tooltip title={tooltipMessage}>
                        <Button
                            disabled={disabled}
                            onClick={(e) => {
                                if (!disabled) {
                                    handleChangeView(curr, prev, e);
                                }
                            }}
                            type="submit"
                            className="documentIcon"
                        >
                            <FileTextIcon />
                        </Button>
                    </Tooltip>
                );
            },
        },
        {
            title: "Current Remarks",
            ellipsis: {
                showTitle: false,
            },
            width: 100,
            key: "remarks",
            dataIndex: "remarks",
            render: (text, record) => (
                <Link to={
                    company_id
                        ? `/admin/company/${company_id}/contracts/${record.id}?tab=6`
                        : `/admin/contracts/${record.id}?tab=6`
                }
                    onClick={(e) => e.stopPropagation()}
                >
                    <button
                        type="submit"
                    >
                        <EmailOutlineIcon />
                    </button>
                </Link>
            ),
        },
        {
            title: "Audit Trails",
            dataIndex: "first_name",
            ellipsis: true,
            width: 100,
            key: 'first_name'
            ,
            render: (text, record) => (
                <Link to={
                    company_id
                        ? `/admin/company/${company_id}/contracts/${record.id}?tab=3`
                        : `/admin/contracts/${record.id}?tab=3`
                }
                    onClick={(e) => e.stopPropagation()}
                >
                    <button
                        type="submit"
                    >
                        <EyeOutlineIcon />
                    </button>
                </Link>
            ),
        },
        // {
        //     title: "View details",
        //     dataIndex: "first_name",
        //     ellipsis: true,
        //     width: 90,
        //     key: "first_name",
        //     render: (text, record) => (
        //         <Link
        //             to={
        //                 company_id
        //                     ? `/admin/company/${company_id}/contracts/${record.id}?referrer=dashboard&tab=1`
        //                     : `/admin/contracts/${record.id}?referrer=dashboard&tab=1`
        //             }
        //         >
        //             <button
        //                 type="submit"
        //             >
        //                 <RightArrowIcon />
        //             </button>
        //         </Link>
        //     ),
        // },

    ], [recentContracts])

    useEffect(() => {
        const fetchRecentContracts = async () => {
            try {
                const payload = {
                    page_size: 10,
                    page_number: 1,
                    company_id: company_id || comp_id
                }
                const response = await axiosInstance.post(`/contract/get/`, payload)
                setRecentContracts(response.data.results);
            } catch (error) { }
        };

        fetchRecentContracts();
    }, []);

    return (
        <div className="flex flex-col md:flex-row">
            <div className="w-full bg-white dark:bg-[#17153B] dark:border-white border-[1px]  rounded-t-lg pl-2">
                <h1
                    className="font-semibold text-[15px] pt-[1%] dark:text-white"
                >
                    Recent Contracts & Audit Trail
                </h1>
                <Table
                    dataSource={recentContracts}
                    columns={columns.map(col => ({
                        ...col,
                        onCell: () => ({
                            style: {
                                padding: "2px 4px !important", // 👈 row cell padding
                                fontSize: "8px !important",   // 👈 row cell font size
                            },
                        }),
                        onHeaderCell: () => ({
                            style: {
                                padding: "2px 4px !important", // 👈 header padding
                                fontSize: "8px !important",   // 👈 header font size
                                fontWeight: 600,
                            },
                        }),
                    }))}
                    pagination={false}
                    size="small"
                    rowKey="id"
                    onRow={(record) => ({
                        onClick: () => {
                            navigate(
                                company_id
                                    ? `/admin/company/${company_id}/contracts/${record.id}?referrer=dashboard&tab=1`
                                    : `/admin/contracts/${record.id}?referrer=dashboard&tab=1`
                            );
                        },
                    })}
                    scroll={{ x: "1200" }}
                    className="
    cursor-pointer mt-1
    [&_.ant-table-cell]:!p-[3px] 
    [&_.ant-table-cell]:!text-[11px] 
    [&_.ant-table-thead_.ant-table-cell]:!text-[11px] 
    [&_.ant-table-thead_.ant-table-cell]:!p-[4px]
  "
                />

            </div>
        </div>
    )
}
